import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UsersApi, UsersApiClient } from '@sg/api/users-api';
import { EnvironmentService, SgEntityBasedSession } from '@sg/common/src';
import { AsyncTracker } from '@sg/utils/src';
import { CookiesSettingsModel } from '../cookies-settings/CookiesSetting.model';

@Component({
  selector: 'sg-cookies-settings-dialog-wrapper',
  templateUrl: './cookies-settings-dialog-wrapper.component.html',
  styleUrls: ['./cookies-settings-dialog-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesSettingsDialogComponent implements OnInit {
  tracker = new AsyncTracker();
  /** Mixpanel is lender-app-only; only persist its consent from the lender app. */
  isLenderApp = this.env.appNameWithoutPrefix === 'lender';

  customSettings = this.fb.control<CookiesSettingsModel>({
    analytical: false,
    mixpanel: false,
  });

  constructor(
    private fb: FormBuilder,
    private usersApi: UsersApiClient,
    public session: SgEntityBasedSession,
    private dialogRef: MatDialogRef<CookiesSettingsDialogComponent>,
    private env: EnvironmentService
  ) {}

  ngOnInit(): void {
    const trackingConsent = this.session?.user?.userSettings?.trackingConsent;
    this.customSettings.setValue({
      analytical: trackingConsent?.heap ?? false,
      mixpanel: trackingConsent?.mixpanel ?? false,
    });
  }

  agreeUserConsent(): void {
    if (!this.session?.user?.userSettings) {
      console.error('Cannot save consent: user session not available');
      return;
    }

    const agreeToAnalytics = this.customSettings.value.analytical;
    const existing = this.session.user.userSettings.trackingConsent;
    // Only write Mixpanel from the lender app; elsewhere keep the stored value untouched.
    const mixpanel = this.isLenderApp ? this.customSettings.value.mixpanel : existing?.mixpanel;
    const userSettings: UsersApi.UserSettingsDto = Object.assign(this.session.user.userSettings, {
      trackingConsent: {
        hotjar: agreeToAnalytics,
        heap: agreeToAnalytics,
        pendo: agreeToAnalytics,
        mixpanel,
      },
    });
    this.usersApi
      .postUsersUserSettings(userSettings, { observe: 'body' })
      .pipe(this.tracker.pipe)
      .subscribe(() => window.location.reload());
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
